/// <reference types="fhir" />

// Import of actions
import * as FhirActions from "../actions/fhir.actions";

export type fhirState = fhir.Resource[];

export const initialState: fhirState = [];

export function fhirReducer(
  state = initialState,
  action: FhirActions.Actions
): fhirState {
  switch (action.type) {
    case FhirActions.RESET_STATE: {
      return initialState;
    }

    case FhirActions.ADD: {
      return state.find(resource => resource.id === action.payload.id)
        ? state
        : [...state, action.payload];
    }

    case FhirActions.REPLACE: {
      return [
        ...state.filter(resource => resource.id !== action.payload.id),
        action.payload // payload is FHIR resource
      ];
    }

    case FhirActions.UPDATE: {
      const { resourceType, id, data } = action.payload;
      return state.map(resource => {
        return resource.id === id && resource.resourceType === resourceType
          ? Object.assign({}, resource, data)
          : resource;
      });
    }

    case FhirActions.DELETE: {
      const { resourceType, id } = action.payload;
      return state.filter(
        resource => resource.resourceType === resourceType && resource.id !== id
      );
    }

    // We do not have a reducer for the LOAD action as it doesn't alter the state
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/store/reducers/fhir.reducer.ts